import axios from "axios"
import { HttpResponse } from "../libs/http"


type SupportLanguagesRes = HttpResponse<{
        language_code: string
        language_name: string
    }[]>

///v1/target_languages
const get_target_langgues = async () => {

    //使用axios
    const http_res = await axios.get("/target_languages")
    const res = http_res.data as SupportLanguagesRes
    return res.data.map(item => {
        return {
            label: item.language_name,
            value: item.language_code
        }
    })
}

export default {
    get_target_languages: get_target_langgues
}